import {
  findIndexByPropertyValue
} from 'utilities/collection';

export default class DataManagerTraits {

  async initialize() {

    this.registerEventHandlers();

    await this.loadAll();

    this.initialized = true;

  }

  tryAdd(item) {

    const itemIndex = findIndexByPropertyValue(this.collection, '_id', item._id);

    if (itemIndex !== -1) {
      return;
    }

    this.collection.push(item);

  }

  tryRemove(itemId) {

    const itemIndex = findIndexByPropertyValue(this.collection, '_id', itemId);

    if (itemIndex === -1) {
      return;
    }

    this.collection.splice(itemIndex, 1);

  }

  getAll() {

    return structuredClone(this.collection);

  }

  getIndexById(itemId) {

    return findIndexByPropertyValue(this.collection, '_id', itemId);

  }

  isExistsById(itemId) {

    const itemIndex = this.getIndexById(itemId);

    return itemIndex !== -1;

  }

  getById(itemId) {

    const itemIndex = this.getIndexById(itemId);

    if (itemIndex === -1) {
      return null;
    }

    return structuredClone(this.collection[itemIndex]);

  }

}